import { render } from "./concept-private.vue?vue&type=template&id=639ef155"
import script from "./concept-private.vue?vue&type=script&lang=js"
export * from "./concept-private.vue?vue&type=script&lang=js"

import "./concept-private.vue?vue&type=style&index=0&id=639ef155&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__